module.exports = __webpack_public_path__ + "img/character-human.ccaa6a88.png";